<template>
  <BaseView title="Vessel Information">
    <!-- MAIN CONTENT -->
    <template #content>
      <!-- CHANGED: added ref="voyageReport" -->
      <v-container
        ref="voyageReport"
        fill-height
        fluid
        class="vessel-container"
      >
        <v-row
          class="vessel-row"
          no-gutters
        >
          <!-- LEFT SIDE -->
          <v-col
            cols="6"
            no-gutters
          >
            <div class="map-placeholder">
              <VoyageMap />
            </div>

            <div class="charts-placeholder">
              <DraggableFuelCharts />
            </div>
          </v-col>

          <!-- RIGHT SIDE -->
          <v-col
            cols="6"
            no-gutters
          >
            <div
              v-if="!isLargeScreen"
              class="top-charts-section"
            >
              <VoyageDataCarousel />
            </div>

            <div
              v-else
              class="top-charts-section"
            >
              <GeneralDataCard :show-displacement-data="showDisplacementData" />
              <SpeedsChart />
            </div>

            <div
              v-if="isLargeScreen"
              class="bottom-charts-section"
            >
              <VesselWindChart />
              <WeatherDataDTNChart />
            </div>

            <div
              v-else
              class="bottom-charts-section"
            >
              <WindChartCarousel />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <!-- INFO ICON -->
    <template #info>
      <InfoIcon :info-data="infoDetails['vessel_info']" />
    </template>

    <!-- HEADER RIGHT SIDE -->
    <template #trailing>
      <div style="display:flex;align-items:center;gap:10px">
        <!-- <ExportPerformanceReport /> -->
        <SelectVoyageLeg />
      </div>
    </template>
  </BaseView>
</template>

<script>

import VesselWindChart from "./components/VesselWindChart.vue";
import SpeedsChart from "./components/SpeedsChart.vue";
import GeneralDataCard from "./components/voyage_data/GeneralDataCard.vue";
import VoyageMap from "./components/map/Map.vue";
import VoyageDataCarousel from "./components/VoyageDataCarousel.vue";
import WindChartCarousel from "./components/WindChartCarousel.vue";
import WeatherDataDTNChart from "./components/WeatherDataDTNChart.vue";
import DraggableFuelCharts from "./components/fuel_charts/FuelCharts.vue";
import ExportPerformanceReport from "./components/ExportPerformanceReport.vue";

import BaseView from "../components/BaseView.vue";
import SelectVoyageLeg from "./components/SelectVoyageLeg.vue";
import InfoIcon from "../../core/InfoIcon.vue";

import { mapState, mapGetters } from "vuex";

export default {

  name: "VesselInformationView",

  components: {
    VesselWindChart,
    SpeedsChart,
    GeneralDataCard,
    VoyageMap,
    VoyageDataCarousel,
    WindChartCarousel,
    DraggableFuelCharts,
    WeatherDataDTNChart,
    BaseView,
    SelectVoyageLeg,
    InfoIcon,
    ExportPerformanceReport
  },

  props: {
    showDisplacementData: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      showErrorSnackBar: false
    };
  },

  computed: {

    ...mapGetters("vesselInformation/voyageModule", [
      "displayDeparturePort",
      "displayArrivalPort",
      "displayTotalDistRun",
      "displayTotalSteamTime",
      "displayDepartureTime",
      "displayEtaNextPort",
      "displayBunkerDate",
      "displayBunkerPort"
    ]),
    ...mapState("vesselInformation", [
      "voyageLegs",
      "selectedLeg"  // ← ADDED: Map selectedLeg to access voyage details
    ]),

    ...mapState("main", [
      "infoDetails"
    ]),

    isLargeScreen() {
      return this.$vuetify.breakpoint.lgAndUp;
    }

  },

  watch: {

    async $route(next, previous) {

      const previousVessel =
        previous.params.vessel;

      const nextVessel =
        next.params.vessel;

      if (previousVessel !== nextVessel) {

        await this.fetchInitialData(
          nextVessel
        );
      }
    }
  },

  async mounted() {

    const vesselName = this.$route.params.vessel;
    this.fetchInitialData(vesselName);

  },

  methods: {

    async fetchInitialData(vesselName) {

      await this.$store.dispatch(
        "vesselInformation/fetchVoyageLegs",
        vesselName
      );

      if (this.voyageLegs.length > 0) {

        await this.$store.commit(
          "vesselInformation/SET_SELECTED_LEG",
          this.voyageLegs[0]
        );

      }

      await this.$store.dispatch(
        "vesselInformation/fetchVoyageData",
        vesselName
      );
    },
  }
};
</script>

<style scoped>

.vessel-container {
  max-height: 100%;
  max-width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  align-items: start;
  padding: 0%;
  background-color: var(--color-primary-light);
}

.vessel-row {
  height: 100%;
}

.map-placeholder {
  height: 50%;
  padding: 5px;
}

.charts-placeholder {
  height: 50%;
  padding: 5px;
}

.top-charts-section {
  height: 50%;
  padding: 5px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.bottom-charts-section {
  height: 50%;
  padding: 5px;
  display: flex;
  flex-direction: row;
  gap: 10px;
}

</style>
